exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Img__image___2Ypbk {\n    opacity: 0;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -khtml-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    vertical-align: top; /* ref: https://stackoverflow.com/a/5804278/6637365 */\n}\n.Img__imageLoaded___360Pk { opacity: 1 }\n.Img__imageLoadedFadein___3lzax { opacity: 1; transition: opacity 0.6s ease; }\n", ""]);

// exports
exports.locals = {
	"image": "Img__image___2Ypbk",
	"imageLoaded": "Img__imageLoaded___360Pk",
	"imageLoadedFadein": "Img__imageLoadedFadein___3lzax"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/Img.icss
// module id = 1207
// module chunks = 0